<template>
    <div>
        <div v-if="!step2">
            <div class="modal-title">Изменение телефона</div>
            <form class="modal-form">
                <input-password
                    label       = "Пароль"
                    required    = "*"
                    placeholder = "Пароль"
                    name        = "password"
                    :errorText  = "errorText.password"
                    @onComplete = "getPasswordValue"
                />
                <input-text
                    label       = "Новый телефон"
                    required    = "*"
                    placeholder = "+7 (___) ___-__-__"
                    maskVal     = "phone"
                    name        = "phone"
                    :errorText  = "errorText.phone"
                    ref         = "phoneInput"
                    @onComplete = "getPhoneValue"
                />
                <div class="modal-button flex">
                    <orange-button
                        text            = "Сохранить"
                        @click.prevent  = "changePhone"
                        ref             = "submitButton"
                    />
                    <button class="button reset" @click.prevent="$emit('showModal')">Отмена</button>
                </div>
            </form>
        </div>
        <div v-else-if="step2">
            <div class="modal-title">Подтверждение телефона</div>
            <a
                href="#"
                class="backward-button"
                @click.prevent="step2 = false"
            >
                <i>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 6.8C11.4418 6.8 11.8 6.44183 11.8 6C11.8 5.55817 11.4418 5.2 11 5.2V6.8ZM0.434315 5.43431C0.121895 5.74673 0.121895 6.25327 0.434315 6.56569L5.52548 11.6569C5.8379 11.9693 6.34443 11.9693 6.65685 11.6569C6.96927 11.3444 6.96927 10.8379 6.65685 10.5255L2.13137 6L6.65685 1.47452C6.96927 1.1621 6.96927 0.655565 6.65685 0.343146C6.34443 0.0307264 5.8379 0.0307264 5.52548 0.343146L0.434315 5.43431ZM11 5.2L1 5.2V6.8L11 6.8V5.2Z"></path>
                    </svg>
                </i>
                Назад
            </a>
            <form class="modal-form">
                <input-text
                    label       = "Код подтверждения"
                    required    = "*"
                    placeholder = "Код подтверждения"
                    name        = "verification_code"
                    :errorText  = "errorText.verification_code"
                    maxlength   = "4"
                    ref         = "codeInput"
                    @onComplete = "getCodeValue"
                />
                <div class="modal-button flex">
                    <orange-button
                        text            = "Подтвердить"
                        @click.prevent  = "confirmPhone"
                        ref             = "submitButton"
                    />
                    <button class="button reset" @click.prevent="$emit('showModal')">Отмена</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import InputText from '@/components/UI/InputText'
import InputPassword from '@/components/UI/InputPassword'
import OrangeButton from '@/components/UI/OrangeButton'

export default {
    name: 'modal-change-phone',
    emits: ['showModal'],
    components: {
        InputText,
        InputPassword,
        OrangeButton,
    },
    data() {
        return {
            apiUrl: this.$store.state.apiUrl,
            token: this.$store.state.token,
            step2: false,
            password: '',
            phone: '',
            verificationCode: '',
            errorText: {
                password: '',
                phone: '',
                verification_code: ''
            }
        }
    },
    methods: {
        getPasswordValue(e) {
            this.password = e.value
        },
        getPhoneValue(e) {
            this.phone = e.value
        },
        getCodeValue(e) {
            this.verificationCode = e.value
        },
        setInputDisabled(status) {
            if (this.$refs.submitButton)
                this.$refs.submitButton.setDisabled(status)
        },
        async changePhone() {
            this.errorText.password = ''
            this.errorText.phone = ''

            this.setInputDisabled(true)

            try {
                await axios.post(
                    this.apiUrl + '/api/user/changePhone',
                    {
                        password: this.password,
                        phone: this.phone,
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        }
                    }
                )
                this.step2 = true
                this.setInputDisabled(false)
            } catch (e) {
                if (e.response && e.response.data && e.response.data.errors) {
                    if (e.response.data.errors.password)
                        this.errorText.password = e.response.data.errors.password[0]

                    if (e.response.data.errors.phone)
                        this.errorText.phone = e.response.data.errors.phone[0]
                } else if (e.response && e.response.data && e.response.data.message) {
                    this.errorText.password = e.response.data.message
                }
                this.setInputDisabled(false)
            }
        },
        async confirmPhone() {
            this.errorText.verification_code = ''

            this.setInputDisabled(true)

            try {
                await axios.post(
                    this.apiUrl + '/api/user/confirmPhone',
                    {
                        phone: this.phone,
                        verification_code: this.verificationCode,
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        }
                    }
                )
                this.$emit('showModal')
                this.$store.commit('getUserInfo')
                this.setInputDisabled(false)
            } catch (e) {
                if (e.response && e.response.data && e.response.data.errors && e.response.data.errors.verification_code) {
                    this.errorText.verification_code = e.response.data.errors.verification_code[0]
                } else if (e.response && e.response.data && e.response.data.message) {
                    this.errorText.verification_code = e.response.data.message
                }
                this.setInputDisabled(false)
            }
        },
    }
}
</script>
